/* eslint-disable max-depth */
/* eslint-disable no-magic-numbers */
/* eslint-disable no-undef */
/* eslint-disable no-new */
import { projectDetailsEndpoint, projectPlacementCreateEndpoint, projectCreativeCreateEndpoint, projectAdgroupCreateEndpoint, projectEmailEndpoint, dimensionEndpoint, projectAdgroupEditEndpoint, projectEmailEditEndpoint, projectPlacementEditEndpoint, projectCreativeEditEndpoint, projectEditEndpoint, projectDeleteCampaign, projectDeletePlacement, projectDeleteAdgroup, projectDeleteEmail, projectDeleteCreative } from './endpoints.js';
import showSnackBar from './snackbar';
import dialogPolyfill from 'dialog-polyfill';
import styleDropDowns from './styledropdowns.js';
import logger from './util-logger';

export default {
    init: () => {
        const params = (new URL(document.location)).searchParams;
        const campaignID = params.get('id');
        const detailsEndpoint = projectDetailsEndpoint + '?id=' + campaignID;
        const form = document.querySelector('form');
        const loader = document.querySelector('.mdl-spinner.mdl-loader');
        const user = localStorage.getItem('data.userSession.csrfToken');
        let goThrough;

        let filterData;
        const adGroupId = window.location.href.indexOf('edit-adgroup') > -1 ?  window.location.search.split('&adgroup=')[1] : '';
        const placementIdforCampaign = window.location.href.indexOf('edit-placement') > -1 ? window.location.search.split('&placementid=')[1] : '';
        const creativeIdforCampaign = window.location.href.indexOf('edit-creative') ? window.location.search.split('&creativeid=')[1] : '';
        const emailId = window.location.href.indexOf('edit-email') > -1 ? window.location.search.split('&email=')[1] : '';
        let noError = false;


        //get requests
        function getCampaignData (url, step) {
            loader.classList.add('is-active');
            const settings = {
                method: 'GET',
                mode: 'cors',
                credentials: 'include',
            };

            const onFail = (error) => {
                logger.crit(error);
            };

            const getdata = new Promise( (resolve) => {
                fetch( dimensionEndpoint, settings)
                    .then( (response) => { return response.json(); })
                    .then( (json) => {
                        filterData = json.data;
                        resolve();
                        return filterData;
                    });
            });
            getdata.then( () => {
                fetch(url, settings)
                    .then( (response) => { return response.json(); })
                    .then( (json) => {
                        loader.classList.remove('is-active');
                        const data = json.data;
                        logger.debug(data);
                        if (document.querySelector('.editCampaign') &&  document.querySelector('#addCampaign') ){
                            document.querySelector('#addCampaign').setAttribute('data-type', data.type);
                        }
                        if ( document.querySelector('.addCreatives') ) {
                            placementsListedOnCreativeForm(data);
                        }
                        return data;
                    }).then( (result) => {
                        if ( document.querySelector('.editAdgroups') ) {
                            populateAdGroups(result);
                        }
                        if ( document.querySelector('.editPlacements') ) {
                            populatePlacements(result);
                        }
                        if ( document.querySelector('.editCreative') ) {
                            populateCreative(result);
                        }
                        if ( document.querySelector('.editEmail') ) {
                            populateEmails(result);
                        }
                        if ( document.querySelector('.editCampaign') && document.querySelector('#addCampaign') ) {
                            populateCampaignForm(result);
                        }
                        return result;
                    }).then( (res) => {
                        if (res) {
                            styleDropDowns();
                        }
                    }).catch((error) => { return onFail(error); } );
            });
        }

        function populateCampaignForm(campaign) {
            const type = campaign.type;
            const form = document.querySelector(`form[data-type=${type}]`);
            document.querySelector('button.btn-create-campaign').innerText = 'Update Campaign';
            const atag = document.createElement('a');
            atag.setAttribute('class', 'mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent reg-button');
            atag.setAttribute('href', '/campaign?id=' + campaignID);
            atag.innerText = 'Cancel';
            document.querySelector('.form-btn-container').append(atag);

            for (const [key, value] of Object.entries(campaign.dimensions)){
                const fields = form.querySelector(`[data-name='${key}']`);

                if (fields.type == 'text' || fields.type == 'date' || fields.type == 'number'){
                    fields.parentElement.classList.add('is-dirty');
                    fields.value = value;
                } else {
                    fields.querySelectorAll('option').forEach( (opt) => {
                        const id = opt.dataset.id;
                        const selValue = value.toString();
                        if ( selValue == id ){
                            const optionsToSelect = value;
                            const select = fields;
                            // logger.debug(select.options.length);
                            for ( let i = 0, l = select.options.length, o; i < l; i++ )
                            {
                                o = select.options[i];
                                //logger.debug(optionsToSelect);
                                // eslint-disable-next-line max-depth
                                if ( optionsToSelect.indexOf( o.value ) != -1 )
                                {
                                    o.selected = true;
                                    // logger.debug(o.selected);
                                }
                            }
                        }
                    });
                }
            }
        }

        function editBtn(btn1, btn2, btnText) {
            btn1.innerText = btnText;
            btn2.innerText = 'Cancel';
            btn2.addEventListener('click', (e) => {
                e.preventDefault();
                window.location.href = '/campaign?id=' + campaignID;
            });
        }

        function formatDate(date) {
            const inputDate = new Date(date);
            return inputDate.toLocaleDateString('en-US', { timeZone: 'UTC', year: 'numeric', month: '2-digit', day: '2-digit' });
        }

        function checkRemoveUrl(formField, value) {
            form.querySelector('[data-name="website_url"]').value = value;
            formField.parentElement.classList.add('is-dirty');
            formField.addEventListener('change', () => {
                if (formField.value == '') {
                    formField.parentElement.classList.remove('is-dirty');
                    formField.parentElement.querySelector('.mdl-textfield__error ').classList.remove('active');
                } else {
                    formField.parentElement.classList.add('is-dirty');
                }
            });
        }

        function populateAdGroups(campaign) {
            const form = document.querySelector('#addAdGroups');
            const addAdGroups = campaign.adGroups;
            const adId = addAdGroups.filter( (addAdGroup) => { return addAdGroup.id == adGroupId; });
            const adDimensions = adId.map( (addAdGroup) => { return addAdGroup.dimensions; });
            const websiteUrl = adId.map( (data) => { return data.website_url ? data.website_url : ''; });
            editBtn( document.querySelector('button.btn-create-add-group'), document.querySelector('button.btn-create-add-ad-group'), 'Update Ad Group');
            if ( adId ) {
                adDimensions.map( (adKey) => {
                    for (const [key, value] of Object.entries(adKey)){
                        const fields = form.querySelector(`[data-name='${key}']`);

                        if (fields.type == 'text' || fields.type == 'date' || fields.type == 'number'){
                            fields.parentElement.classList.add('is-dirty');
                            fields.value = value;
                            if ( fields.value == 'null'){
                                fields.value = '';
                            }
                        } else {
                            fields.querySelectorAll('option').forEach( (opt) => {
                                const id = opt.dataset.id;
                                const selValue = value[0].toString();
                                if ( selValue == id ){
                                    const optionsToSelect = value;
                                    const select = fields;
                                    for ( let i = 0, l = select.options.length, o; i < l; i++ )
                                    {
                                        o = select.options[i];
                                        if ( optionsToSelect.indexOf( o.value ) != -1 )
                                        {
                                            o.selected = true;
                                        }
                                    }
                                    if (opt.selected) {
                                        opt.parentElement.parentElement.querySelector('.floating-label').classList.add('active');
                                    }
                                }
                            });
                        }
                    }
                });
                if (websiteUrl != '') {
                    for (const value of Object.entries(websiteUrl)){
                        checkRemoveUrl(form.querySelector('[data-name="website_url"]'), value[1]);
                    }
                }
            }
        }

        function populatePlacements(campaign) {
            const form = document.querySelector('form#addPlacements');
            const thePlacements = campaign.placements;
            const placementId = thePlacements.filter( (data) => { return data.id == placementIdforCampaign; });
            const placementDimensions = placementId.map( (data) => { return data.dimensions; });
            editBtn( document.querySelector('button.btn-create-placement'), document.querySelector('button.btn-add-placement'), 'Update Placement');
            if ( placementId ) {
                placementDimensions.map( (adKey) => {
                    for (const [key, value] of Object.entries(adKey)){
                        const fields = form.querySelector(`[data-name='${key}']`);

                        if (fields.type == 'text' || fields.type == 'date' || fields.type == 'number'){
                            fields.parentElement.classList.add('is-dirty');
                            fields.value = value;
                            if ( fields.value == 'null'){
                                fields.value = '';
                            }
                        } else {
                            fields.querySelectorAll('option').forEach( (opt) => {
                                const id = opt.dataset.id;
                                const selValue = value[0].toString();
                                if ( selValue == id ){
                                    const optionsToSelect = value;
                                    const select = fields;
                                    for ( let i = 0, l = select.options.length, o; i < l; i++ )
                                    {
                                        o = select.options[i];
                                        if ( optionsToSelect.indexOf( o.value ) != -1 )
                                        {
                                            o.selected = true;
                                        }
                                    }
                                    if (opt.selected) {
                                        opt.parentElement.parentElement.querySelector('.floating-label').classList.add('active');
                                    }
                                }
                            });
                        }
                    }
                });
            }
            return placementIdforCampaign;
        }

        function populateCreative(campaign) {
            const getplacementId = window.location.search.split('&placementid=')[1].split('&creativeid=')[0];
            const form = document.querySelector('form#addCreatives');
            const placements = campaign.placements.filter( (data) => {  return data.id == getplacementId; });
            document.querySelector('.placements-selected').setAttribute('hidden', '');
            placements.map( (data) => {
                const pCreative = data.creatives;
                const cs = pCreative.filter( (data) => {  return data.id == creativeIdforCampaign; });
                cs.map((c) => {
                    if (c.website_url) {
                        const websiteUrlField = form.querySelector('[data-name="website_url"]');
                        websiteUrlField.parentElement.classList.add('is-dirty');
                        websiteUrlField.value = c.website_url;
                    }

                    for (const [key, value] of Object.entries(c.dimensions)){
                        const fields = form.querySelector(`[data-name='${key}']`);

                        if (fields.type == 'text' || fields.type == 'date' || fields.type == 'number'){
                            fields.parentElement.classList.add('is-dirty');
                            fields.value = value;
                            if ( fields.value == 'null'){
                                fields.value = '';
                            }
                        } else {
                            fields.querySelectorAll('option').forEach( (opt) => {
                                const id = opt.dataset.id;
                                const selValue = value[0].toString();
                                if ( selValue == id ){
                                    const optionsToSelect = value;
                                    const select = fields;
                                    for ( let i = 0, l = select.options.length, o; i < l; i++ )
                                    {
                                        o = select.options[i];
                                        if ( optionsToSelect.indexOf( o.value ) != -1 )
                                        {
                                            o.selected = true;
                                        }
                                    }
                                    if (opt.selected) {
                                        opt.parentElement.parentElement.querySelector('.floating-label').classList.add('active');
                                    }
                                }
                            });
                        }
                    }
                });
            });
            editBtn( document.querySelector('button.btn-create-creatives'), document.querySelector('button.btn-create-add-creatives'), 'Update Creative');
            return creativeIdforCampaign;
        }

        function populateEmails(campaign) {
            const form = document.querySelector('#addEmailNames');
            const campaignEmails = campaign.emails;
            const theEmailId = campaignEmails.filter( (data) => { return data.id == emailId; });
            const emailDimensions = theEmailId.map( (data) => { return data.dimensions; });
            const websiteUrl = campaignEmails.map( (data) => { return data.website_url ? data.website_url : ''; });
            emailDimensions.map( (eKey) => {
                for (const [key, value] of Object.entries(eKey)){
                    const fields = form.querySelector(`[data-name='${key}']`);

                    if (fields.type == 'text' || fields.type == 'date' || fields.type == 'number'){
                        fields.parentElement.classList.add('is-dirty');
                        fields.value = value;
                    } else {
                        fields.querySelectorAll('option').forEach( (opt) => {
                            const id = opt.dataset.id;
                            const selValue = value[0].toString();
                            if ( selValue == id ){
                                const optionsToSelect = value;
                                const select = fields;
                                for ( let i = 0, l = select.options.length, o; i < l; i++ )
                                {
                                    o = select.options[i];
                                    if ( optionsToSelect.indexOf( o.value ) != -1 )
                                    {
                                        o.selected = true;
                                    }
                                }
                                if (opt.selected) {
                                    opt.parentElement.parentElement.querySelector('.floating-label').classList.add('active');
                                }
                            }
                        });
                    }
                }
            });

            if (websiteUrl != '') {
                for (const value of Object.entries(websiteUrl)){
                    checkRemoveUrl(form.querySelector('[data-name="website_url"]'), value[1]);
                }
            }
            editBtn( document.querySelector('button.btn-create-email-names'), document.querySelector('button.btn-create-add-email-names'), 'Update Email');
        }

        function onSuccess(message) {
            goThrough = true;
            noError  = true;
            showSnackBar.showMessage(message);
            if ( document.querySelector('.editCampaign')) {
                const redirectTime = 5001;
                setTimeout( () => {
                    window.location.href = '/campaign?id=' + campaignID;
                }, redirectTime);
            }
            return noError;
        }

        //sending form data
        function getSelectedFormValues(form, id){
            const token = { 'csrfToken': user };
            const campId = document.querySelector('.addPage') ? { 'campaignId': id } : { 'id': id };
            const placements = document.querySelector('select#placementIds') ? [...document.querySelector('select#placementIds').selectedOptions].map((opt) => { return opt.value; }) : '';
            const placementIds = { 'placementIds': placements };
            const url = form.querySelector('input[data-name="website_url"]') ? form.querySelector('input[data-name="website_url"]').value : '';
            const websiteUrl = { 'website_url': url };
            const formObject = {};
            Array.from(form.querySelectorAll('input[type="text"]:not([data-name="website_url"]),select:not(#placementIds),input[type="number"],input[type="date"]')).filter((elem) => { return elem.dataset.name; }).forEach((elem) => {
                if (elem.options) {
                    const selected = [...elem.selectedOptions].map((opt) => { return opt.value.split('|')[0]; });
                    formObject[elem.dataset.name] = selected;
                } else if (elem.type == 'date'){
                    formObject[elem.dataset.name] = formatDate(elem.value);
                    if ( !elem.value ){
                        formObject[elem.dataset.name] = null;
                    }
                } else if (elem.type == 'number') {
                    formObject[elem.dataset.name] = parseInt(elem.value);
                    if ( !elem.value ){
                        formObject[elem.dataset.name] = null;
                    }
                } else {
                    formObject[elem.dataset.name] = elem.value;
                }
            });
            const dimensions = { 'dimensions': formObject };
            const wholeObj = {};
            Object.assign(wholeObj, token);
            Object.assign(wholeObj, dimensions);

            document.querySelector('.addPlacements') ? Object.assign(wholeObj, campId) : '';

            if (document.querySelector('.addCreatives, .editCreative')){
                Object.assign(wholeObj, placementIds);
                url != '' ? Object.assign(wholeObj, websiteUrl) : '';
            }

            document.querySelector('.editPlacements') ? Object.assign(wholeObj, campId) : '';

            if (document.querySelector('.editCreative') || document.querySelector('.editCampaignName')){
                Object.assign(wholeObj, campId);
            }

            if ( document.querySelector('.addAdgroups') ||  document.querySelector('#addAdGroups')) {
                Object.assign(wholeObj, campId);
                if ( form.querySelector('input[data-name="website_url"]').value != ''){
                    Object.assign(wholeObj, websiteUrl);
                }
            }

            if (document.querySelector('.addEmails') ||  document.querySelector('#addEmailNames')){
                Object.assign(wholeObj, campId);
                if ( form.querySelector('input[data-name="website_url"]').value != ''){
                    Object.assign(wholeObj, websiteUrl);
                }
            }

            logger.debug(wholeObj);
            return wholeObj;
        }

        function failFormError(data){
            const msg = data;
            const err = msg.errors;
            logger.info(err);
            for ( const key of Object.entries(err)) {
                if ( key == 'E030') {
                    document.querySelector('.err-container').removeAttribute('hidden');
                    document.querySelector('.err-container strong').innerText = 'This item already exists';
                } else {
                    document.querySelector('.err-container').removeAttribute('hidden');
                    document.querySelector('.err-container strong').innerText = 'Error occured';
                }
                document.querySelector('.err-container').scrollIntoView({ behavior: 'smooth' });
            }
        }

        //post requests
        function createCallback(data, endpoint, message){
            const fetchSettings = {
                method: 'POST',
                body: JSON.stringify(data),
                mode: 'cors',
                credentials: 'include',
                headers: new Headers({
                    'Content-Type': 'application/json'
                })
            };
            loader.classList.add('is-active');
            let success = false;
            fetch(endpoint, fetchSettings)
                .then((response) => { return response.json(); })
                .then( (data) => {
                    loader.classList.remove('is-active');
                    logger.debug(data);
                    data.success === true ? onSuccess(message) : logger.high('error') ;
                    if (data.success === false) {
                        failFormError(data);
                        noError = false;
                        return false;
                    } else {
                        success = true;
                        if (document.querySelector('.err-container')){
                            document.querySelector('.err-container').setAttribute('hidden', '');
                        }
                    }
                    return success;
                }).then( () => {
                    if ( !document.querySelector('.editCampaign') || !document.querySelector('.campaignDetails') || !document.querySelector('.editMode')) {
                        success == true ? clearFields() : '' ;
                    }
                });
        }

        function clearFields(){
            if ( form && !document.querySelector('.editCampaign') ) {
                const fields = form.querySelectorAll('select, input[type="text"], input[type="date"], input[type="number"]');
                fields.forEach((field) => {
                    if ( field.type == 'select'){
                        resetSelectElement(field);
                        logger.debug(field.tomselect);
                        field.clearOptions();
                        field.tomselect.clear();
                        logger.debug(field.parentElement);
                        field.parentElement.querySelector('label.floating-label.active').classList.remove('active');
                        field.parentElement.querySelector('.mdl-textfield__error.active').classList.remove('active');
                    } else if ( field.type == 'text' || field.type == 'date' || field.type == 'number' ) {
                        field.value = '';
                        field.parentElement.classList.remove('is-dirty');
                    }
                });
                form.querySelectorAll('.ts-wrapper .item a').forEach( (opt) => {
                    const parentEl = opt.parentElement.parentElement.parentElement.parentElement;
                    opt.click();
                    parentEl.querySelector('label.floating-label.active') ?  parentEl.querySelector('label.floating-label.active').classList.remove('active') : '';
                    parentEl.querySelector('.mdl-textfield__error.active') ? parentEl.querySelector('.mdl-textfield__error.active').classList.remove('active') : '';
                });
                form.scrollIntoView({ behavior: 'smooth' } );
            }
        }

        function redirectToCampaign(id) {
            const num = 5500;
            setTimeout( () => {
                window.location.href = `/campaign?id=${id}`;
            }, num);
        }

        function filterRefs(dim, ref) {
            if ( ref ) {
                return ref.length > 1 ? ref.map( (item) => { return filterList(dim, item); } ) : filterList(dim, ref);
            }
        }

        function placementsListedOnCreativeForm(data){
            data.placements.map( (d) => {
                document.querySelectorAll('select#placementIds').forEach((select) => {
                    const newFormValue = new URLSearchParams(d.dimensions).toString();
                    const res = newFormValue.split('&').map((item) => {
                        return [item.split('=')[0], item.split('=')[1].split('%2C')];
                    }).filter((word) => { return word.length > 1; }).reduce((acc, item) => {
                        // eslint-disable-next-line no-magic-numbers
                        if ( acc.keys.indexOf(item[0]) === -1) {
                            acc.keys.push(item[0]);
                            acc.output.push(item);
                        }
                        return { output: acc.output, keys: acc.keys };
                    }, { output: [], keys: [] });
                    const joinedString = res.output.map( (i) => {
                        const filterRefVal = filterRefs(i[0], i[1]);
                        return  !filterRefVal || ( Array.isArray(filterRefVal) && filterRefVal.filter( x => x).length == 0 ) ? i[1].toString().replace(/\++/g, ' ' ) : filterRefVal;
                    }).join('|');
                    const option = document.createElement('option');
                    option.setAttribute('data-id', d.id);
                    option.setAttribute('value', `${d.id}`);
                    option.innerText = joinedString;
                    select.append(option);
                });
            });

            const campaignSelects = document.querySelectorAll('.creative-multi-select select');
            campaignSelects.forEach( (select) => {
                new TomSelect(select, {
                    plugins: ['remove_button'],
                    onDropdownOpen: function(dropdown) {
                        dropdown.parentElement.parentElement.querySelector('label.floating-label').classList.add('active');
                    },
                    onDropdownClose: function(dropdown) {
                        if ( dropdown.querySelectorAll('.selected').length == 0){
                            dropdown.parentElement.parentElement.querySelector('label.floating-label').classList.add('active');
                        }
                    },
                    onBlur: function(){
                        if ( this.wrapper.querySelectorAll('.selected').length == 0){
                            this.wrapper.parentElement.querySelector('label.floating-label').classList.add('active');
                        }
                    },
                    onChange: function(){
                        this.wrapper.classList.toggle('is-invalid', !this.isValid);
                    },
                });
            });
        }

        function filterList(dimensionName, referenceName){
            const dims = filterData.dimensions;
            const refValues = dims.filter( (dim) => {
                if ( dim.type == 'Lookup'){
                    return dim.reference_values;
                }
            });
            const dimensionValues = dims.map( (dim) => {
                return dim.id  == dimensionName ? dim.name : '';
            });

            const dimensionValue = dimensionValues.join('').toString();
            const refVal = refValues.map( (refValue) => {
                for ( const [key, value] of Object.entries(refValue.reference_values)){
                    if ( key == referenceName && key ) {
                        const val = value.split(',');
                        return [...val];
                    }
                }
            });
            const ref_val = refVal.join('').toString();
            return ref_val;
        }

        function validateFields(form){
            const fields = form.querySelectorAll('select[required], input[type="text"][data-required], input[type="date"][data-required]');
            fields.forEach((field) => {
                if (!field.value){
                    form.querySelector('.form-err-msg').classList.add('active');
                    form.scrollIntoView({ behavior: 'smooth' });
                    noError = false;
                    return false;
                } else {
                    if (form.querySelectorAll('.mdl-textfield__error.active').length == 0 ) {
                        form.querySelector('.form-err-msg').classList.remove('active');
                        noError = true;
                    }
                    return true;
                }
            });

            return noError;
        }

        function resetSelectElement(selectElement) {
            const options = selectElement.options;
            // Look for a default selected option
            for (let i = 0, iLen = options.length; i < iLen; i++) {
                if (options[i].defaultSelected) {
                    selectElement.selectedIndex = i;
                    return;
                }
            }
            // If no option is the default, select first or none as appropriate
            selectElement.selectedIndex = 0; // or -1 for no option selected
        }

        function deleteDialog(endpoint, id, loc, message) {
            const dialog = document.querySelector('dialog');
            if (!dialog.showModal) {
                // eslint-disable-next-line no-undef
                dialogPolyfill.registerDialog(dialog);
            }
            dialog.showModal();
            //safari fix
            dialog.removeAttribute('hidden');

            dialog.querySelector('.mdl-button.yes').addEventListener('click', () => {
                deleteCampaign(endpoint, id, loc, message);
            });
            dialog.querySelector('.close').addEventListener('click', function() {
                dialog.close();
                dialog.setAttribute('hidden', '');
            });
        }

        // delete Campaign projectDeleteCampaign
        function deleteCampaign(endpoint, id, loc, message){
            const obj = {};
            const user = localStorage.getItem('data.userSession.csrfToken');
            const token = { 'csrfToken': user };
            const cId = { 'id': id };
            Object.assign(obj, token);
            Object.assign(obj, cId);
            const num = 3700;
            function deletePromise() {
                return new Promise( (resolve, reject) => {
                    if ( createCallback(obj, endpoint, message) && goThrough == true ) {
                        resolve();
                        return true;
                    } else {
                        reject();
                    }
                }).then(setTimeout( () => {
                    window.location.href = loc;
                }, num)).catch((e) => {
                    logger.crit(e);
                });
            }
            deletePromise();
        }

        //submission for edit forms
        function submitEditForms(editform, button, id, endpoint, message) {
            if ( document.querySelector('.editCampaign') && editform ){
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (validateFields(form)) {
                        createCallback(getSelectedFormValues(editform, id), endpoint, message);
                    } else {
                        return false;
                    }
                });
            }
        }

        submitEditForms(document.querySelector('form#addCampaign'), document.querySelector('button.mdl-button.btn-create-campaign'), campaignID, projectEditEndpoint, 'Changes Saved for Campaign Name!');

        submitEditForms(document.querySelector('form#addAdGroups'), document.querySelector('button.mdl-button.btn-create-add-group'), adGroupId, projectAdgroupEditEndpoint, 'Changes Saved for Ad Group!');

        submitEditForms(document.querySelector('form#addEmailNames'), document.querySelector('button.btn-create-email-names'), emailId, projectEmailEditEndpoint, 'Changes Saved for Email!');


        submitEditForms(document.querySelector('form#addPlacements'), document.querySelector('button.btn-create-placement'), placementIdforCampaign, projectPlacementEditEndpoint, 'Changes for Placement Saved!');

        submitEditForms(document.querySelector('form#addCreatives'), document.querySelector('button.btn-create-creatives'), creativeIdforCampaign, projectCreativeEditEndpoint, 'Changes for Creatives Saved!');


        function getResultsFromCampaignItemCall(form, campaignId, endpoint, message){
            if (validateFields(form)) {
                createCallback(getSelectedFormValues(form, campaignId), endpoint, message);
            } else {
                return false;
            }
        }

        //function for when 1 campaign item is added
        function sendCampaignData(func){
            generatePromise();
            function generatePromise(){
                return new Promise( (resolve) => {
                    func;
                    resolve();
                }).then(() => {
                    logger.debug(noError);
                    if ( noError === true ) {
                        setTimeout( () => { redirectToCampaign(campaignID); }, 4800);
                    }
                }).catch((e) => { logger.crit(e); });
            }
        }

        function sendCampaignDataAndClearForm(func, step){
            if (  func ) {
                step.scrollIntoView({ behavior: 'smooth' });
            }
        }

        function addPlacementsForm() {
            form.removeAttribute('hidden');
            getCampaignData(detailsEndpoint, document.querySelector('#mediaStepTwo'));
            document.querySelector('form#addPlacements').addEventListener('submit', (e) => {
                e.preventDefault();
            });
            document.querySelector('form#addPlacements .btn-create-placement').addEventListener('click', (e) => {
                e.preventDefault();
                sendCampaignData(getResultsFromCampaignItemCall(form, campaignID, projectPlacementCreateEndpoint, 'Placements Added'));
            });
            document.querySelector('form#addPlacements .btn-add-placement').addEventListener('click', (e) => {
                e.preventDefault();
                sendCampaignDataAndClearForm(getResultsFromCampaignItemCall(form, campaignID, projectPlacementCreateEndpoint, 'Placements Added'), document.querySelector('#searchStepTwo'));
            });
        }

        function addCreativesForm(){
            form.removeAttribute('hidden');

            getCampaignData(detailsEndpoint, document.querySelector('#mediaStepThree'));
            document.querySelector('form#addCreatives').addEventListener('submit', (e) => {
                e.preventDefault();
            });
            document.querySelector('form#addCreatives .btn-create-creatives').addEventListener('click', (e) => {
                e.preventDefault();
                sendCampaignData(getResultsFromCampaignItemCall(form, campaignID, projectCreativeCreateEndpoint, 'Creatives Added'));
            });
            document.querySelector('form#addCreatives .btn-create-add-creatives').addEventListener('click', (e) => {
                e.preventDefault();
                sendCampaignDataAndClearForm(getResultsFromCampaignItemCall(form, campaignID, projectCreativeCreateEndpoint, 'Creatives Added'), document.querySelector('#mediaStepThree'));
            });
        }

        function addAdGroupsForm(){
            form.removeAttribute('hidden');

            getCampaignData(detailsEndpoint, document.querySelector('#searchStepTwo'));
            document.querySelector('form#addAdGroups').addEventListener('submit', (e) => {
                e.preventDefault();
            });
            document.querySelector('form#addAdGroups .btn-create-add-group').addEventListener('click', (e) => {
                e.preventDefault();
                sendCampaignData(getResultsFromCampaignItemCall(form, campaignID, projectAdgroupCreateEndpoint, 'Ad Group Created'));
            });
            document.querySelector('form#addAdGroups .btn-create-add-ad-group').addEventListener('click', (e) => {
                e.preventDefault();
                sendCampaignDataAndClearForm(getResultsFromCampaignItemCall(form, campaignID, projectAdgroupCreateEndpoint, 'Ad Group Created'), document.querySelector('#searchStepTwo'));
            });
        }

        function addEmailsForm() {
            form.removeAttribute('hidden');

            getCampaignData(detailsEndpoint, document.querySelector('#emailStepTwo'));
            document.querySelector('form#addEmailNames').addEventListener('submit', (e) => {
                e.preventDefault();
            });
            document.querySelector('form#addEmailNames .btn-create-email-names').addEventListener('click', (e) => {
                e.preventDefault();
                sendCampaignData(getResultsFromCampaignItemCall(form, campaignID, projectEmailEndpoint, 'Email Created'));
            });
            document.querySelector('form#addEmailNames .btn-create-add-email-names').addEventListener('click', (e) => {
                e.preventDefault();
                sendCampaignDataAndClearForm(getResultsFromCampaignItemCall(form, campaignID, projectEmailEndpoint, 'Email Created'), document.querySelector('#emailStepTwo'));
            });
        }

        if ( document.querySelector('.addPlacements') ) {
            addPlacementsForm();
        }
        if ( document.querySelector('.addCreatives') ) {
            addCreativesForm();
        }
        if ( document.querySelector('.addAdgroups') ) {
            addAdGroupsForm();
        }
        if ( document.querySelector('.addEmails') ) {
            addEmailsForm();
        }

        if ( document.querySelector('.editCampaign') ) {
            const num = 2000;
            setTimeout( () => {
                getCampaignData(detailsEndpoint);
            }, num);
        }

        if ( document.querySelector('.campaignDetails') ) {
            document.addEventListener('click', function(e){
                if (e.target && e.target.id == 'delete-campaign'){
                    deleteDialog(projectDeleteCampaign, campaignID, '/campaigns', 'Campaign Deleted');
                }
                if (e.target && e.target.className.indexOf('delete-placement-btn') > -1)  {
                    const thePlacementId = e.target.dataset.campaign;
                    deleteDialog(projectDeletePlacement, thePlacementId, '/campaign?id=' + campaignID, 'Placement Deleted');
                }
                if (e.target && e.target.className.indexOf('delete-creative-btn') > -1)  {
                    const theCreativeId = e.target.dataset.creative;
                    deleteDialog(projectDeleteCreative, theCreativeId, '/campaign?id=' + campaignID, 'Creative Deleted');
                }
                if (e.target && e.target.className.indexOf('delete-adgroup-btn') > -1)  {
                    const theAdgroupId = e.target.dataset.adgroup;
                    deleteDialog(projectDeleteAdgroup, theAdgroupId, '/campaign?id=' + campaignID, 'Adgroup Deleted');
                }
                if (e.target && e.target.className.indexOf('delete-email-btn') > -1)  {
                    const theEmailId = e.target.dataset.email;
                    deleteDialog(projectDeleteEmail, theEmailId, '/campaign?id=' + campaignID, 'Email Deleted');
                }
            });
        }
    }
};
